import Vue from 'vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Router from 'vue-router'
import simple from '@/views/layout/simple.vue'
import Auth from '@/utils/auth.js'
NProgress.configure({
  showSpinner: false
})

Vue.use(Router)
const router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [{
    path: '/',
    redirect: '/index'
  }, {
    path: '/index',
    name: 'index',
    meta: {
      title: '首页'
    },
    //首页
    component: () => import( /* webpackChunkName: "index" */ '@/views/index')
  }, {
    path: '/about',
    name: 'about',
    meta: {
      title: '关于我们'
    },
    //关于我们
    component: () => import( /* webpackChunkName: "about" */ '@/views/about')
  },
  
  {
    path: '/information',
    name: 'information',
    meta: {
      title: '行业资讯'
    },
    //精选栏目
    component: () => import( /* webpackChunkName: "product" */ '@/views/information')
  }, {
    path: '/solution/digitalize',
    name: 'digitalize',
    meta: {
      title: '数字科技解决方案'
    },
    //数字化
    component: () => import( /* webpackChunkName: "digitalize" */ '@/views/solution/digitalize')
  }, {
    path: '/solution/blockchain',
    name: 'blockchain',
    meta: {
      title: '区块链解决方案'
    },
    //区块链
    component: () => import( /* webpackChunkName: "blockchain" */ '@/views/solution/blockchain')
  }, {
    path: '/solution/finance',
    name: 'finance',
    meta: {
      title: '金融科技解决方案'
    },
    //金融科技
    component: () => import( /* webpackChunkName: "finance" */ '@/views/solution/finance')
  }, {
    path: '/coreTechnology',
    name: 'coreTechnology',
    meta: {
      title: '核心技术'
    },
    //核心技术
    component: () => import( /* webpackChunkName: "coreTechnology" */ '@/views/coreTechnology')
  },
  {
    path: '/product',
    name: 'product',
    meta: {
      title: '核心产品'
    },
    //核心产品
    component: () => import( /* webpackChunkName: "product" */ '@/views/product')
  },
  {
    path: '/columns',
    name: 'columns',
    meta: {
      title: '精选栏目'
    },
    //精选栏目
    component: () => import( /* webpackChunkName: "product" */ '@/views/columns')
  },

  ]
})

router.beforeEach((to, from, next) => {
  // 开启进度条
  NProgress.start()
  if (to.meta.title) {
    document.title = to.meta.title
  }
  //next()
  next()
  // if (Auth.isLogin()) {
  //   next()
  // } else {
  //   if (to.path === '/login') {

  //   } else {
  //     next({
  //       path: '/login',
  //       replace: true
  //     })
  //   }
  // }
})

router.afterEach(() => {
  window.scrollTo(0, 0);
  NProgress.done() // 结束Progress
})
export default router